/**
* Created by kongwm.kong on 2017/7/26.
*/
<template>
    <div>
        <modal name="upload-success" :width="580" :height="auto">
            <div class="vue-modal-wrap">
                <div class="modal-title">提示信息<span @click="hide">x</span></div>
                <div class="modal-bd">
                   <h1>上传成功</h1>
                    <div class="ps">
                        我们将于1个工作日内审核完毕，如有任何意见或者细节疑问反馈，<br>
                        请致电：0755-29330548（陈小姐）<br>
                        或发送邮件至：data@jfz.com进行对接
                    </div>
                    <button class="btn-bg-def" @click="hide">确定</button>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
    export default {
        data(){
            return {

            }
        },
        methods : {
            show(){
                this.$modal.show('upload-success');
            },
            hide(){
                this.$modal.hide('upload-success');
            }
        }
    }
</script>
<style lang="scss" type="text/scss" scoped>
    .vue-modal-wrap{
        @include bgff;
        width:580px;
        .modal-bd{
            padding: 40px 50px ;
            h1{
                color:$btn_408;
                font-size: 22px;
                font-weight: bold;
                text-align: center;
                margin-bottom:15px;
            }
            .ps{
                color:$c_666;
                font-size:16px;
                line-height:24px;
                margin-bottom:40px;
            }
            button{
                width:204px;
                height:50px;
                font-size:18px;
                display: block;
                margin: 0 auto;
                color:#fff;
                font-weight: bold;
                text-align: center;
                line-height: 50px;
                cursor: pointer;
                background: $btn_408;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/modal/uploadSuc.vue